<template>
  <div class="straddleHold">
    <vxe-grid
      border
      highlight-hover-row
      highlight-current-row
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :max-height="$store.state.app.tableHeight"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      column-min-width="150"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import API from '@/api/futuresStrategy/index';
  export default {
    name: 'straddleHold',
    props: ['ptcombiRow', 'heightNew'],
    computed: {
      columnList() {
        return [
          { type: 'seq', title: this.$t('table.index'), width: 60 }, // 序号
          {
            field: 'futuCode',
            title: this.$t('futuresStrategy.futuresStrategyList.table.futuCode'),
          }, // 合约代码
          {
            field: 'stockName',
            width: 120,
            title: this.$t('futuresStrategy.futuresStrategyList.table.stockName'),
          }, // 合约名称
          {
            field: 'moneyType',
            title: this.$t('futuresStrategy.futuresStrategyList.table.moneyType'),
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('strategy_currency'),
              props: {
                clearable: true,
              },
            },
          }, // 币种
          {
            field: 'combiHoldType',
            title: this.$t('futuresStrategy.futuresStrategyList.table.combiHoldType'),
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('hold_direction'),
              props: {
                clearable: true,
              },
            },
          }, // 持仓方向
          {
            field: 'squarePrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.squarePrice'),
          }, //市场价格
          {
            field: 'averageOpenPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.averageOpenPrice'),
          }, //开仓价格
          {
            field: 'openAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.openAmount'),
          }, // 开仓数量
          {
            field: 'sumAverageOpenPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sumAverageOpenPrice'),
            formatter: this.formatterBaseInfo,
          }, // 累计开仓均价
          {
            field: 'sumOpenAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sumOpenAmount'),
            formatter: this.formatterBaseInfo,
          }, //累计开仓数量
          {
            field: 'averageHoldPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.averageHoldPrice'),
            formatter: this.formatterMarginAmount,
          }, // 持仓均价
          {
            field: 'currentAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.currentAmount'),
            formatter: this.formatterMarginAmount,
          }, //持仓数量
          {
            field: 'averageDropPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.averageDropPrice'),
          }, // 平仓均价
          {
            field: 'dropAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.dropAmount'),
          }, // 平仓数量
          {
            field: 'sumAverageDropPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sumAverageDropPrice'),
          }, // 累计平仓均价
          {
            field: 'sumDropAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sumDropAmount'),
          }, // 累计平仓数量
          {
            field: 'holdIncomeFloat',
            title: this.$t('futuresStrategy.futuresStrategyList.table.holdIncomeFloat'),
          }, // 浮动盈亏
          {
            field: 'dropIncomeAdd',
            title: this.$t('futuresStrategy.futuresStrategyList.table.actualIncome'),
          }, // 实现盈亏
          {
            field: 'totalFare',
            title: this.$t('futuresStrategy.futuresStrategyList.table.totalFare'),
          }, // 交易手续费
          {
            field: 'modifyDate',
            title: this.$t('futuresStrategy.futuresStrategyList.table.modifyDate'),
          }, // 持仓更新日期
        ];
      },
    },
    data() {
      return {
        tableData: [],
      };
    },
    methods: {
      //获取table数据
      getData() {
        const params = { ptcombiNo: this.ptcombiRow.row.ptcombiNo };
        this.load = true;
        this.$axios.post(API.LIST_COMBIHOLDSINFO, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data;
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .currentTitle {
    line-height: 15px;
    height: 35px;
    margin-top: 20px;
  }
</style>
